export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '35224069-1008-4b94-88ec-11868b055bf2';
export const MODAL_CLOSE_SEC = 2.5;
